import { IJurisdictionContextData } from 'interfaces/commons/IContext';
import { createContext } from 'react';

export const JurisdictionContext = createContext<IJurisdictionContextData>({} as IJurisdictionContextData);
